import CryptoJS from 'crypto-js';

const cryptoKey = process.env.REACT_APP_CRYPTOJS_KEY || '';

const encryptAndEncodeObject = (originalObject: any): string => {
  // Encriptar el objeto
  const encrypted = CryptoJS.AES.encrypt(originalObject, cryptoKey).toString();

  const encoded = encrypted;

  return encoded;
};

const urlSafeBase64Decode = (input: string): string => {
  let output = input.replace(/-/g, '+').replace(/_/g, '/');
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += '==';
      break;
    case 3:
      output += '=';
      break;
    default:
      throw new Error('Invalid base64 URL string');
  }
  return output;
};

export { encryptAndEncodeObject };
